export default {"src":"/_next/static/media/timezone.c7851ec0.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};